// extracted by mini-css-extract-plugin
export var playerWrapper = "featureVid-module--playerWrapper--2uHTq";
export var reactPlayer = "featureVid-module--reactPlayer--dIdE_";